'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "FullscreenBar": "Polaris-FullscreenBar",
  "BackAction": "Polaris-FullscreenBar__BackAction"
};

exports.default = styles;
